// extracted by mini-css-extract-plugin
export default {"section":"Certification_section__YMdV9","heading":"Certification_heading__WbGAL","container":"Certification_container__76-sO"};